import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
	return (
		<footer className="footer">
			<div className="footer-main">
				<div className="container footer-grid">
					{/* Brand column */}
					<div className="footer-col footer-brand-col">
						<div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12 }}>
							<svg width="40" height="40" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
								<rect width="72" height="72" rx="14" fill="#c0392b"/>
								<path d="M12 52 36 18 60 52H46L36 34 26 52H12Z" fill="white"/>
								<path d="M22 52h28v4H22z" fill="white" opacity="0.5"/>
							</svg>
							<div>
								<div style={{ fontWeight: 800, color: '#fff', fontSize: 15, lineHeight: 1.2 }}>Apex Specialty</div>
								<div style={{ fontWeight: 600, color: 'rgba(255,255,255,0.7)', fontSize: 12 }}>Contracting LLC</div>
							</div>
						</div>
						<p style={{ color: 'rgba(255,255,255,0.65)', fontSize: 13, lineHeight: 1.6, margin: '0 0 14px' }}>
							Licensed &amp; insured roofing and storm restoration contractors serving the Tampa Bay area since 2021. Quality workmanship guaranteed.
						</p>
						<div className="footer-social">
							<a href="https://www.facebook.com/" target="_blank" rel="noopener noreferrer" className="footer-social-icon" aria-label="Facebook">
								<svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/></svg>
							</a>
							<a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer" className="footer-social-icon" aria-label="Instagram">
								<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/></svg>
							</a>
							<a href="https://www.linkedin.com/" target="_blank" rel="noopener noreferrer" className="footer-social-icon" aria-label="LinkedIn">
								<svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/><rect x="2" y="9" width="4" height="12"/><circle cx="4" cy="4" r="2"/></svg>
							</a>
							<a href="https://twitter.com/" target="_blank" rel="noopener noreferrer" className="footer-social-icon" aria-label="Twitter / X">
								<svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M4 4l16 16M4 20 20 4" stroke="currentColor" strokeWidth="0"/><path d="M3 3h4.5l13.5 18H17L3 3Zm0 18 7-8m7.5-7L21 3"/></svg>
							</a>
						</div>
					</div>

					{/* Services column */}
					<div className="footer-col">
						<h4 className="footer-heading">Our Services</h4>
						<ul className="footer-links">
							<li><Link to="/services">Roof Replacement</Link></li>
							<li><Link to="/services">Storm Damage Repair</Link></li>
							<li><Link to="/services">Roof Inspection</Link></li>
							<li><Link to="/services">Insurance Claims Help</Link></li>
							<li><Link to="/services">Gutter Installation</Link></li>
							<li><Link to="/services">Commercial Roofing</Link></li>
						</ul>
					</div>

					{/* Company column */}
					<div className="footer-col">
						<h4 className="footer-heading">Company</h4>
						<ul className="footer-links">
							<li><Link to="/about">About Us</Link></li>
							<li><Link to="/case-studies">Our Projects</Link></li>
							<li><Link to="/industries">Service Areas</Link></li>
							<li><Link to="/faq">FAQ</Link></li>
							<li><Link to="/contact">Contact Us</Link></li>
							<li><Link to="/business-verification">Business Verification</Link></li>
						</ul>
					</div>

					{/* Contact column */}
					<div className="footer-col">
						<h4 className="footer-heading">Contact Us</h4>
						<ul className="footer-contact-list">
							<li>
								<svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" fill="currentColor"/></svg>
								183 Highland Rd, Tarpon Springs, FL 34689
							</li>
							<li>
								<svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.6 10.8c1.4 2.8 3.8 5.1 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.1.4 2.3.6 3.6.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1-9.4 0-17-7.6-17-17 0-.6.4-1 1-1h3.5c.6 0 1 .4 1 1 0 1.3.2 2.5.6 3.6.1.3 0 .7-.2 1L6.6 10.8z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
								<a href="tel:9163160696">(916) 316-0696</a>
							</li>
							<li>
								<svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 4h16v16H4V4Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/><path d="M4 4l8 8 8-8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
								<a href="mailto:info@appexconnecthub.com">info@appexconnecthub.com</a>
							</li>
							<li>
								<svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 4h16v16H4V4Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/><path d="M4 4l8 8 8-8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
								<a href="mailto:support@appexconnecthub.com">support@appexconnecthub.com</a>
							</li>
							<li>
								<svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.5"/><path d="M12 7v5l3 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>
								Mon–Fri: 7:00 AM – 6:00 PM
							</li>
						</ul>
					</div>
				</div>
			</div>

			{/* SMS Disclosure */}
			<div className="footer-disclosure">
				<div className="container">
					<p>
						By providing your phone number and checking the SMS consent box, you agree to receive marketing text messages from APEX SPECIALTY CONTRACTING LLC (Appex Connect Hub) regarding roofing estimates, appointment reminders, project updates, and promotional offers. Message frequency varies. Message and data rates may apply. Reply <strong>STOP</strong> to opt out at any time. Reply <strong>HELP</strong> for assistance. Consent is not required to receive services.
					</p>
				</div>
			</div>

			{/* Bottom bar */}
			<div className="footer-bottom">
				<div className="container footer-bottom-inner">
					<p>© {new Date().getFullYear()} APEX SPECIALTY CONTRACTING LLC. All rights reserved. | FL License #XXXXX2536</p>
					<div className="legal">
						<Link to="/privacy">Privacy Policy</Link>
						<Link to="/terms">Terms of Use</Link>
						<Link to="/sms-policy">SMS Policy</Link>
						<Link to="/opt-out">Opt-Out</Link>
						<Link to="/accessibility">Accessibility</Link>
					</div>
				</div>
			</div>
		</footer>
	);
}

export default Footer;


